module.exports = __webpack_public_path__ + "static/media/Week 4 Sunday.4b903629.png";